import PropTypes from 'prop-types'
import React from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import { NavLink } from 'react-router-dom'
import Typography from 'gu-ui-kit/Typography'
import styles from '../nav.module.scss'

const AuditsLink = React.forwardRef(
  ({ className, activeClassName, exact, to, children, ...rest }, ref) => {
    const { audit = 0 } = useSelector(
      (state) => ({
        audit: state.notifications?.counters?.audit,
      }),
      shallowEqual,
    )

    return (
      <NavLink
        activeClassName={activeClassName}
        className={className}
        exact={exact}
        innerRef={ref}
        to={to}
        {...rest}
      >
        {children}
        {audit !== 0 && (
          <Typography
            className={styles['nav__link-badge']}
            component={'span'}
            variant={'Body-10'}
          >
            {audit}
          </Typography>
        )}
      </NavLink>
    )
  },
)

AuditsLink.displayName = 'AuditsLink'

export default AuditsLink

AuditsLink.propTypes = {
  className: PropTypes.string,
  activeClassName: PropTypes.string,
  exact: PropTypes.bool,
  to: PropTypes.string,
  children: PropTypes.node,
}
